const ELLIPSIS = '…';

export const trimTextForMetaDescription =
	(maxLength = 160) =>
	(text: string): string => {
		const trimmedText = text.trim();

		if (trimmedText.length <= maxLength) {
			return trimmedText;
		}

		const maxTextLength = maxLength - ELLIPSIS.length;

		const lastSentenceIndex = Math.min(trimmedText.lastIndexOf('. '), trimmedText.lastIndexOf('! '), trimmedText.lastIndexOf('? '));

		if (lastSentenceIndex !== -1 && lastSentenceIndex >= maxTextLength) {
			return trimmedText.slice(0, lastSentenceIndex + 1);
		}

		const lastWordIndex = trimmedText.lastIndexOf(' ', maxTextLength);
		if (lastWordIndex !== -1) {
			return trimmedText.slice(0, lastWordIndex) + ELLIPSIS;
		}

		return trimmedText.slice(0, maxTextLength) + ELLIPSIS;
	};
